module.exports = __webpack_public_path__ + "static/media/location.80c51d0b.PNG";